export const FETCH_AGE_DATA = 'FETCH_AGE_DATA';
export const FETCH_COUNTRY_CITY_DATA = 'FETCH_COUNTRY_CITY_DATA';
export const FETCH_GENDER_DATA = 'FETCH_GENDER_DATA';
